import Vue from 'vue'
import { baseDataService } from './mixins/itemDataServiceMixins'

export default new (Vue.extend({
	defaultPath: 'team/focus',
	mixins: [baseDataService],
}))()
